import React, { useCallback } from "react";
import ICheckbox from "./ICheckbox";
import SelectionsSimple from "../../../common/SelectionsSimple";
import SubGroup from "../../../common/SubGroup";

function GeneralTab({ profile }) {
  const handleChanged = useCallback(
    (value, key) => {
      profile[key] = value;
      profile[`Change${key}`] = true;

      console.log(profile);
    },
    [profile]
  );

  return (
    <div className="grid h-full grid-cols-3 gap-2">
      <div className="grid grid-cols-2 col-span-2 gap-2 h-min">
        {/* First Row */}
        <SubGroup title="MLB Pitcher Change" className="!gap-0 p-2">
          <ICheckbox
            label="Pitcher Change Type"
            onChanged={(value) => handleChanged(value, "PC_PitcherChangeType")}
          />
          <ICheckbox
            label="Skip Side"
            onChanged={(value) => handleChanged(value, "PC_SkipSide")}
          />
          <ICheckbox
            label="Skip Total"
            onChanged={(value) => handleChanged(value, "PC_SkipTotal")}
          />
          <ICheckbox
            label="Skip Run Line"
            onChanged={(value) => handleChanged(value, "PC_SkipRunLine")}
          />
        </SubGroup>
        <SubGroup title="MLB Short Game" className="!gap-0 p-2">
          <ICheckbox
            label="Cancel Side"
            onChanged={(value) => handleChanged(value, "SG_CancelSide")}
          />
          <ICheckbox
            label="Cancel Total"
            onChanged={(value) => handleChanged(value, "SG_CancelTotal")}
          />
          <ICheckbox
            label="Cancel Run Line"
            onChanged={(value) => handleChanged(value, "SG_CancelRunLine")}
          />
        </SubGroup>
        {/* Second Row */}
        <SubGroup title="Duplicated Bets" className="!gap-0 p-2 col-span-2">
          <ICheckbox
            label="Check Parlays with Straight Limit"
            onChanged={(value) =>
              handleChanged(value, "DuplicateBetsCheckParlaysSB")
            }
          />
          <ICheckbox
            label="Check Teasers with Straight Limit"
            onChanged={(value) =>
              handleChanged(value, "DuplicateBetsCheckTeasersSB")
            }
          />
          <ICheckbox
            label="Check If Bets & Reverses with Straight Limit"
            onChanged={(value) =>
              handleChanged(value, "DuplicateBetsCheckIfSBRev")
            }
          />
          <ICheckbox
            label="Check Parlays With Same Details"
            onChanged={(value) =>
              handleChanged(value, "DuplicateBetsCheckSameParlay")
            }
          />
          <ICheckbox
            label="Check Teasers With Same Details"
            onChanged={(value) =>
              handleChanged(value, "DuplicateBetsCheckTeasersSB")
            }
          />

          <SubGroup
            title="Don't allow Duplicated Bets on"
            className="!gap-0 p-2 mt-2"
          >
            <ICheckbox
              label="Line Changes"
              onChanged={(value) =>
                handleChanged(value, "DuplicateBetsCheckLineChange")
              }
            />
            <ICheckbox
              label="Parlays"
              onChanged={(value) =>
                handleChanged(value, "DuplicateBetsCheckParlays")
              }
            />
            <ICheckbox
              label="If Bets"
              onChanged={(value) =>
                handleChanged(value, "DuplicateBetsCheckIfbets")
              }
            />
            <ICheckbox
              label="Teasers"
              onChanged={(value) =>
                handleChanged(value, "DuplicateBetsCheckTeasers")
              }
            />
            <ICheckbox
              label="Reverses"
              onChanged={(value) =>
                handleChanged(value, "DuplicateBetsCheckReverses")
              }
            />
          </SubGroup>
        </SubGroup>
        {/* Third Row */}
        <SubGroup title="Free Plays" className="!gap-0 p-2 col-span-2">
          <ICheckbox
            label="Allow Both Sides"
            onChanged={(value) => handleChanged(value, "FPAllowBothSides")}
          />
          <ICheckbox
            label="Allow Duplicated Bets"
            onChanged={(value) => handleChanged(value, "FPAllowDuplicatedBets")}
          />
          <ICheckbox
            label="Check Office Filters"
            onChanged={(value) => handleChanged(value, "FPCheckOfficeFilters")}
          />
          <ICheckbox
            label="Max Number of Favs"
            onChanged={(value) => handleChanged(value, "FPMaxFav")}
          />
          <ICheckbox
            label="Max Number of Teams"
            onChanged={(value) => handleChanged(value, "FPMaxTeams")}
          />
          <ICheckbox
            label="Max Payout"
            onChanged={(value) => handleChanged(value, "FPMaxPayout")}
          />
          <ICheckbox
            label="Odds Limit"
            onChanged={(value) => handleChanged(value, "FPOddsLimit")}
          />
        </SubGroup>
        {/* Fourth Row */}
        <SubGroup title="Card Limits" className="!gap-0 p-2 col-span-2">
          <ICheckbox
            label="Max Wager"
            onChanged={(value) => handleChanged(value, "CLMaxWager")}
          />
        </SubGroup>
        {/* Fifth Row */}
        <div className="!gap-0 p-2 col-span-2">
          <ICheckbox
            label="Allow Hookups in Related Soccer Games"
            onChanged={(value) => handleChanged(value, "SOC_Hookups")}
          />
          <ICheckbox
            label="Allow Open Spots in Reverses"
            onChanged={(value) => handleChanged(value, "Rev_AllowOpen")}
          />
        </div>
      </div>
      <div className="flex flex-col h-full min-h-0 col-span-1 gap-2">
        <SelectionsSimple
          className="simple-table h-1/2"
          // GET
          itemKey="Value"
          getUrl={"/Profile/Period_GetListAll"}
          getProcess={(data) =>
            data.map(({ IdSport, NumberOfPeriod, PeriodDescription }) => ({
              Value: `${IdSport?.trim()}-${NumberOfPeriod}`,
              Text: `${IdSport} - ${PeriodDescription}`,
            }))
          }
          // CHANGE
          onChanged={(selected) => {
            const IdSportsPeriods = [];
            selected.map((item) => {
              const [IdSport, IdPeriod] = item.split("-");
              IdSportsPeriods.push({
                IdSport,
                IdPeriod,
              });
            });
            profile["GameRelatedOptions"] = {
              ...profile["GameRelatedOptions"],
              IdSportsPeriods,
            };

            console.log(profile);
          }}
        >
          <TableHeaderColumn
            visible="none"
            isKey={true}
            hidden
            dataField="Value"
          >
            Value
          </TableHeaderColumn>
          <TableHeaderColumn dataField="Text" filter={{ type: "TextFilter" }}>
            Related Period Options
          </TableHeaderColumn>
        </SelectionsSimple>
        <SelectionsSimple
          className="simple-table h-1/2"
          // GET
          itemKey="Value"
          initialData={[
            { Value: "MLDog_Over", Text: "Dog Money Line / Total Over" },
            { Value: "MLDog_Under", Text: "Dog Money Line / Total Under" },
            { Value: "MLFav_Under", Text: "Fav Money Line / Total Under" },
            { Value: "MLFav_Over", Text: "Fav Money Line / Total Over" },
            { Value: "SprDog_Over", Text: "Dog Spread / Total Over" },
            { Value: "SprDog_Under", Text: "Dog Spread / Total Under" },
            { Value: "SprFav_Over", Text: "Fav Spread / Total Over" },
            { Value: "SprFav_Under", Text: "Fav Spread / Total Under" },
          ]}
          // CHANGE
          onChanged={(selected) => {
            profile["GameRelatedOptions"] = {
              IdSportsPeriods: profile["GameRelatedOptions"]?.IdSportsPeriods,
              ...selected.reduce(
                (acc, item) => ({
                  ...acc,
                  [item]: true,
                  [`Change${item}`]: true,
                }),
                {}
              ),
            };
            console.log(profile);
          }}
        >
          <TableHeaderColumn
            visible="none"
            isKey={true}
            hidden
            dataField="Value"
          >
            Value
          </TableHeaderColumn>
          <TableHeaderColumn dataField="Text" filter={{ type: "TextFilter" }}>
            Related Game Options
          </TableHeaderColumn>
        </SelectionsSimple>
      </div>
    </div>
  );
}

export default GeneralTab;
